import Vue from 'vue'
import axios from 'axios';
import numeral from 'numeral';
import moment from 'moment';
import api from './models/coreapi';
import Vuelidate from 'vuelidate';
Vue.use(Vuelidate);
import Swal from 'sweetalert2';
export default {
	install(Vue) {
		Vue.prototype.$base = function () {
			return api.base();
		};

		Vue.prototype.$api = function () {
			return axios.create({
				baseURL: api.base(),
				headers: { Authorization: 'Bearer ' + api.getToken() }
			});
		};

		Vue.prototype.$isValid = (res) => {
			return api.isValid(res);
		}

		Vue.prototype.$now = function () {
			return moment();
		};

		Vue.prototype.$format = function (value, format) {
			if (value == null) return '';

			return moment(value).format(format);
		};		

		Vue.prototype.$formats = function (value) {
			return moment(value).format('DD-MMM-YYYY');
		};
		
		Vue.prototype.$formatFromTo = function (value, from, to) {
			if (value == null) return '';
			return moment(value, from).format(to);
		};

		Vue.prototype.$number = function (value, format) {
			return numeral(value).format(format);
		};

		Vue.prototype.$money = function (value) {
			return numeral(value).format('$0,0.00');
		};

		Vue.prototype.$dollar = function (value) {
			return numeral(value).format('$0,0.00');
		};

		Vue.prototype.$dollar2 = function (value) {
			if (value != 0 && value != 0.00)
				return numeral(value).format('$0,0.00');
		};
		
		Vue.prototype.$riel = function (value) {
			let exchangeRate = 4000;
			const exchange = this.$store.state.exchange;
			if (exchange != undefined && exchange != null) {
				exchangeRate = exchange.Value;
			}
			return "៛" + numeral(value * exchangeRate).format('0,0.00');
		};

		Vue.prototype.$startOfMonth = () => {
			return moment().startOf('month').format('YYYY-MM-DD');
		}

		Vue.prototype.$endOfMonth = () => {
			return moment().endOf('month').format('YYYY-MM-DD');
		}

		Vue.prototype.$isKeyNumber = function (evt) {
			evt = (evt) ? evt : window.event;
			var charCode = (evt.which) ? evt.which : evt.keyCode;
			if ((charCode > 31 && (charCode < 48 || charCode > 57)) && charCode !== 46) {
				evt.preventDefault();
			} else {
				return true;
			}
		}

		Vue.prototype.$tokh = (value) => {
			var arr_num = ['០', '១', '២', '៣', '៤', '៥', '៦', '៧', '៨', '៩'];
			var result = '';
			for (var index = 0; index < value.length; index++) {
				var i = value[index];
				if (!isNaN(parseFloat(i)) && isFinite(i)) {
					result = result + arr_num[i];
				} else {
					result = result + value[index];
				}
			}
			return result;
		}

		Vue.prototype.$day = (day_name) => {
			var arr_day = {
				'Mon': 'ច័ន្ទ',
				'Tue': 'អង្គារ៍',
				'Wed': 'ពុធ',
				'Thu': 'ព្រហ',
				'Fri': 'សុក្រ',
				'Sat': 'សៅរ៍',
				'Sun': 'អាទិត្យ',
			};
			return arr_day[day_name];
		}

		Vue.prototype.$month = (month) => {
			let months = ["មករា", "កុម្ភៈ", "មីនា", "មេសា", "ឧសភា", "មិថុនា", "កក្តដា", "សីហា", "កញ្ញា", "តុលា", "វិច្ឆិកា", "ធ្នូ"];
			let result = '';
			if (month > 0 && month <= 12) {
				result = months[month];
			}

			return result;
		}

		Vue.prototype.$statusLabel = (status) => {
			var success = ['Posted', 'In Payment', 'To Invoice', 'Paid', 'Done'];
			if (status == 'Draft' || status == 'Pending') return '<span class="badge badge-info">' + status + '</span>';
			else if (status == 'Quotation') return '<span class="badge badge-primary">' + status + '</span>';
			else if (status == 'Not Paid') return '<span class="badge badge-danger">' + status + '</span>';
			else if (success.includes(status)) return '<span class="badge badge-success">' + status + '</span>';
			else if (status == 'Partially Paid' || status == 'Nothing To Invoice') return '<span class="badge badge-warning">' + status + '</span>';
		}

		Vue.prototype.$years = () => {
			var result = [];
			var syear = 2021;
			var cyear = new Date().getFullYear();
			var n = cyear - syear;
			if(n > 0){
				for(var i = 0; i <= n; i++){
					result.push(syear + i);
				}
			}else result.push(syear);

			return result;
		}

		Vue.prototype.$productTypes = () => {
			return [
				{ id: 1, lang: 'inventory'},
				{ id: 2, lang: 'non_inventory'},
				{ id: 3, lang: 'service'}
			];
		}

		Vue.prototype.$filterDateTypes = () => {
			return [
				{ id: 1, lang: 'this_month'},
				{ id: 2, lang: 'this_week'},
				{ id: 3, lang: 'custom_date'}
			];
		}

		Vue.prototype.$paymentTerms = () => {
			return [
				{ id: "Cash Payout", lang: 'cash_payout'},
				{ id: "Pay Later", lang: 'pay_later'},
			];
		}

		Vue.prototype.$swal = Swal;

		Vue.prototype.$isEmpty = function (value) {
			if (value == null || value == undefined || value == "") {
				return true;
			}
			return false;
		};

		Vue.prototype.$checkBranchType = function (value) {
			if(value == 1) {
				return 'office' ;
			} else if(value == 2) {
				return 'stock' ;
			} else if(value == 3) {
				return 'shop' ;
			} else if(value == 4) {
				return 'farm' ;
			}
		}
	}
}